import classNames from 'classnames';
import { LoadingElement } from 'ii-react-sdk/layout_components';
import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useUser } from '~/providers/user';
import Permissions from '~/settings/permissions';
import { useRecentActivity } from '../providers';
import ComparisonActivityResult from './comparisons_tab/comparison_activity_result';
import DocumentActivityResult from './document_tab/document_activity_result';
const TABLE_CHUNK_SIZE = 25;
const ActivityGrid = (props) => {
    var _a, _b;
    const { recentDocumentActivities, recentComparisonActivities } = props;
    const { hasPermission } = useUser();
    const { isLoadingComparisons, isLoadingDocuments } = useRecentActivity();
    const [documentTable, setDocumentTable] = useState([]);
    const [comparisonTable, setComparisonTable] = useState([]);
    useEffect(() => {
        if (recentComparisonActivities === null || recentComparisonActivities === void 0 ? void 0 : recentComparisonActivities.length) {
            setComparisonTable(recentComparisonActivities.slice(0, TABLE_CHUNK_SIZE));
        }
    }, [recentComparisonActivities]);
    useEffect(() => {
        if (recentDocumentActivities === null || recentDocumentActivities === void 0 ? void 0 : recentDocumentActivities.length) {
            setDocumentTable(recentDocumentActivities.slice(0, TABLE_CHUNK_SIZE));
        }
    }, [recentDocumentActivities]);
    const takeMore = () => {
        if (recentDocumentActivities === null || recentDocumentActivities === void 0 ? void 0 : recentDocumentActivities.length) {
            setDocumentTable(recentDocumentActivities.slice(0, documentTable.length + TABLE_CHUNK_SIZE));
        }
        if (recentComparisonActivities === null || recentComparisonActivities === void 0 ? void 0 : recentComparisonActivities.length) {
            setComparisonTable(recentComparisonActivities.slice(0, comparisonTable.length + TABLE_CHUNK_SIZE));
        }
    };
    const hasMultipleTabs = hasPermission(Permissions.VIEW_RECENT_ACTIVITY_DOCUMENTS) &&
        hasPermission(Permissions.VIEW_RECENT_ACTIVITY_DOCUMENT_COMPARISONS);
    const bodyClasses = classNames('results-table-body', { 'with-tabs': hasMultipleTabs });
    const totalRows = (_b = (_a = recentComparisonActivities === null || recentComparisonActivities === void 0 ? void 0 : recentComparisonActivities.length) !== null && _a !== void 0 ? _a : recentDocumentActivities === null || recentDocumentActivities === void 0 ? void 0 : recentDocumentActivities.length) !== null && _b !== void 0 ? _b : 0;
    return (React.createElement("div", { className: 'recent-activity-grid-container' },
        React.createElement("div", { className: 'results-table-header' },
            React.createElement("h5", { className: 'date-col' }, "Date"),
            React.createElement("h5", { className: 'activity-col' }, "Activity"),
            React.createElement("h5", { className: 'documents-col' }, "Documents")),
        React.createElement("div", { className: bodyClasses },
            (isLoadingComparisons || isLoadingDocuments) &&
                React.createElement("div", { className: 'loading-activity-container' },
                    React.createElement("div", { className: 'loading-activity-grid-icon' },
                        React.createElement(LoadingElement, { isLightBackground: true }))),
            !(isLoadingComparisons || isLoadingDocuments) &&
                React.createElement("div", { className: 'results-table-items', id: 'scrollable-results' },
                    (documentTable === null || documentTable === void 0 ? void 0 : documentTable.length) !== 0 && React.createElement(InfiniteScroll, { dataLength: documentTable.length, next: takeMore, hasMore: documentTable.length !== totalRows, loader: React.createElement("div", { className: 'loading-results' }, "Loading More Activities..."), scrollableTarget: 'scrollable-results', style: { overflow: 'none' } }, documentTable.map((activity) => {
                        return React.createElement(DocumentActivityResult, { activity: activity, key: activity.fileId });
                    })),
                    (comparisonTable === null || comparisonTable === void 0 ? void 0 : comparisonTable.length) !== 0 && React.createElement(InfiniteScroll, { dataLength: comparisonTable.length, next: takeMore, hasMore: comparisonTable.length !== totalRows, loader: React.createElement("div", { className: 'loading-results' }, "Loading More Activities..."), scrollableTarget: 'scrollable-results', style: { overflow: 'none' } }, comparisonTable.map(activity => {
                        return React.createElement(ComparisonActivityResult, { activity: activity, key: activity.id });
                    }))))));
};
export default ActivityGrid;
